import * as React from 'react';
import { ApplicationMain } from 'src/styles/common';
import LoaderComponent from 'src/components/common/loader.component';
import { Grid, Typography, Link } from '@material-ui/core';
import { UnauthorizedWrapper } from 'src/styles/unauthorized';
import { getLocalStorageValue } from 'src/effects/utils/local-storage';
import { connect } from 'react-redux';
import { logout } from 'src/actions/action.userAuth';
import { push } from 'connected-react-router';
import { getAdalConfig } from 'src/effects/api/api.userAuth';
import { AuthenticationContext } from 'react-adal';
import { SYNC_SURVEY_GET_USER_COUNTRIES_KEY } from 'src/constants/constants';


class ErrorComponent extends React.Component<any, any> {

    constructor(props: any) {
        super(props);

        this.handleLogout = this.handleLogout.bind(this);
    }

    handleLogout() {
        const loggedInUser = getLocalStorageValue('user');
        if (loggedInUser && loggedInUser.isInternalUser) {
            localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
            localStorage.removeItem('user');
            this.props.logout();

            getAdalConfig().then((adalConfig) => {
                if (adalConfig) {
                    const authContext = new AuthenticationContext(adalConfig)
                    authContext.logOut();
                }
            });

        }
        else {
            if (loggedInUser) {
                localStorage.removeItem(`UserId_${loggedInUser.id}_${SYNC_SURVEY_GET_USER_COUNTRIES_KEY}`)
            }
            localStorage.removeItem('user');
            this.props.logout();
            this.props.redirectTo("/login");
        }
    }

    render() {
        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />

                <UnauthorizedWrapper>

                    <div className="pageContainer pageNotFoundContainer">



                        <div className="pageContent">
                            <Grid container={true}>
                                <Grid item={true} xs={12}>

                                    <div className="error-wrapper">


                                        <section className="error-container">
                                            <h1 className="notice">Page Not Found</h1>

                                            <span className="four"><span className="screen-reader-text">4</span></span>
                                            <span className="zero"><span className="screen-reader-text">0</span></span>
                                            <span className="four"><span className="screen-reader-text">4</span></span>
                                        </section>
                                        <div className="link-container">
                                            <Typography>
                                                <Link href="javascript:void(0);" onClick={this.handleLogout} className="pageLink">
                                                    Login Again
                                                </Link>
                                            </Typography>
                                        </div>

                                    </div>


                                </Grid>
                            </Grid>
                        </div>

                    </div>

                </UnauthorizedWrapper>

            </ApplicationMain>
        );
    }


}


const mapStateToProps = (state: any) => {
    return {
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (path: string) => dispatch(push(path)),
        logout: () => dispatch(logout())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ErrorComponent);


// WEBPACK FOOTER //
// ./src/components/common/ErrorComponent.tsx